import {Component, Input, OnInit} from '@angular/core';
import {BlacklistRemarkModel} from '../../../shared/dto/blacklist-remark.model';

@Component({
  selector: 'app-blacklist-details',
  templateUrl: './blacklist-details.component.html',
  styleUrls: ['./blacklist-details.component.scss']
})
export class BlacklistDetailsComponent implements OnInit {
  @Input() data: BlacklistRemarkModel[];
  @Input() dataEXM: BlacklistRemarkModel[];
  @Input() dataDG: BlacklistRemarkModel[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  constructor() { }

  ngOnInit() {
  }

}
